"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _has2 = _interopRequireDefault(require("lodash/has"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _isFunction2 = _interopRequireDefault(require("lodash/isFunction"));
var _size2 = _interopRequireDefault(require("lodash/size"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _react = _interopRequireWildcard(require("react"));
var _reactWindowInfiniteLoader = _interopRequireDefault(require("react-window-infinite-loader"));
var _reactVirtualizedAutoSizer = _interopRequireDefault(require("react-virtualized-auto-sizer"));
var _reactWindow = require("react-window");
var _hooks = require("../../hooks");
var _excluded = ["component"],
  _excluded2 = ["isItemLoaded", "itemCount", "minimumBatchSize", "onItemsRendered", "onLoadRequest", "threshold", "flexible", "children", "onScroll", "onScrollTopBorder", "onScrollBottomBorder", "isReverse", "isNextPageLoading", "itemData", "onDidUpdateItems"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var MINIMUM_BATCH_SIZE = 100;
var THRESHOLD_DEFAULT = 10;
var DEFAULT_ITEM_SIZE = 30;
var StyledVirtualizedList = (0, _styledComponents["default"])(function (_ref) {
  var component = _ref.component,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].cloneElement(component, _objectSpread(_objectSpread({}, props), {}, {
    ref: props.forwardRef
  }));
}).withConfig({
  displayName: "InfiniteList__StyledVirtualizedList",
  componentId: "sc-1cpqm0k-0"
})(["", ";> div{position:", ";}::-webkit-scrollbar{width:4px;}::-webkit-scrollbar-thumb{background-color:#c2c5cc;border-radius:40px;}"], function (_ref2) {
  var isColumnReverse = _ref2.isColumnReverse;
  return isColumnReverse && "\n    display: flex;\n    flex-direction: column-reverse;\n  ";
}, function (_ref3) {
  var isColumnReverse = _ref3.isColumnReverse;
  return isColumnReverse ? 'relative' : 'static';
});
var StyledPolygon = _styledComponents["default"].div.withConfig({
  displayName: "InfiniteList__StyledPolygon",
  componentId: "sc-1cpqm0k-1"
})(["position:absolute;width:100%;visibility:hidden;"]);
var PolygonList = /*#__PURE__*/_react["default"].memo( /*#__PURE__*/_react["default"].forwardRef(function (_ref4, outerRef) {
  var polygons = _ref4.polygons,
    itemData = _ref4.itemData,
    onPolygonsRendered = _ref4.onPolygonsRendered;
  var innerRef = (0, _react.useRef)();
  var handlePolygonsRendered = (0, _react.useCallback)(function () {
    if (innerRef.current) {
      var items = innerRef.current.querySelectorAll('img,svg');
      var itemsLoaderList = [];
      if (document && document.fonts && document.fonts.ready) {
        itemsLoaderList.push(document.fonts.ready);
      }
      if (items && items.length > 0) {
        items.forEach(function (item) {
          itemsLoaderList.push(new Promise(function (resolve, reject) {
            if (item.complete || item.tagName.toLowerCase() === 'svg' && item.getBoundingClientRect().width !== 0 || item.getBoundingClientRect().height !== 0) {
              resolve();
            } else {
              item.addEventListener('load', function () {
                return resolve();
              });
              item.addEventListener('error', function () {
                return reject();
              });
            }
          }));
        });
      }
      Promise.allSettled(itemsLoaderList).then(function () {
        onPolygonsRendered();
      });
    }
  }, [polygons, polygons.length]);
  return /*#__PURE__*/_react["default"].createElement(_reactVirtualizedAutoSizer["default"], null, function (_ref5) {
    var height = _ref5.height,
      width = _ref5.width;
    return /*#__PURE__*/_react["default"].createElement(StyledPolygon, {
      height: height,
      width: width,
      ref: function ref(_ref6) {
        innerRef.current = _ref6;
        outerRef.current = _ref6;
        handlePolygonsRendered();
      }
    }, itemData.map(function (data, index) {
      return polygons({
        data: itemData,
        index: index
      });
    }));
  });
}));
PolygonList.displayName = 'PolygonList';
var InfiniteList = /*#__PURE__*/_react["default"].forwardRef(function (props, outerRef) {
  var isItemLoaded = props.isItemLoaded,
    itemCount = props.itemCount,
    minimumBatchSize = props.minimumBatchSize,
    _onItemsRendered = props.onItemsRendered,
    onLoadRequest = props.onLoadRequest,
    threshold = props.threshold,
    flexible = props.flexible,
    children = props.children,
    onScroll = props.onScroll,
    onScrollTopBorder = props.onScrollTopBorder,
    onScrollBottomBorder = props.onScrollBottomBorder,
    isReverse = props.isReverse,
    isNextPageLoading = props.isNextPageLoading,
    itemData = props.itemData,
    onDidUpdateItems = props.onDidUpdateItems,
    restProps = (0, _objectWithoutProperties2["default"])(props, _excluded2);
  var _useState = (0, _react.useState)([]),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    itemSizes = _useState2[0],
    setItemSizes = _useState2[1];
  var _useState3 = (0, _react.useState)(isReverse),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    isStartReverseScrollToBottom = _useState4[0],
    setIsStartReverseScrollToBottom = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    isReversePaginationStart = _useState6[0],
    setIsReversePaginationStart = _useState6[1];
  var _useState7 = (0, _react.useState)(true),
    _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
    isPolygonCalculation = _useState8[0],
    setIsPolygonCalculation = _useState8[1];
  var listRef = (0, _react.useRef)();
  var innerListRef = (0, _react.useRef)();
  var polygonRef = (0, _react.useRef)();
  var prevItemSizes = (0, _hooks.usePrevious)(itemSizes);
  var scrollToLastItemReverse = (0, _react.useCallback)(function () {
    if (isReverse && listRef.current) {
      var offset = 0;
      for (var i = (0, _size2["default"])(prevItemSizes); i < (0, _size2["default"])(itemSizes); i += 1) {
        offset += itemSizes[i];
      }
      listRef.current.scrollTo(offset);
    }
    setIsReversePaginationStart(false);
  }, [itemSizes, itemSizes.length]);
  var calculateItemSizes = (0, _react.useCallback)(function () {
    if (!polygonRef.current) {
      return;
    }
    var polygonItems = polygonRef.current.querySelectorAll("".concat(StyledPolygon, " > *"));
    if ((0, _isEmpty2["default"])(polygonItems)) {
      return;
    }
    var newItemSizes = [];
    polygonItems.forEach(function (itemElement, index) {
      var scrollHeight = itemElement.scrollHeight;
      newItemSizes[index] = scrollHeight;
    });
    setItemSizes(newItemSizes);
    setIsPolygonCalculation(false);
  }, [polygonRef]);
  var handleScroll = (0, _react.useCallback)(function (event) {
    onScroll(event);
    if (!outerRef || !outerRef.current) return;
    var currentOuterRef = outerRef.current;
    if (event.scrollOffset <= 0 && isReverse && !isStartReverseScrollToBottom) {
      onLoadRequest();
      onScrollTopBorder();
    }
    if (event.scrollOffset + currentOuterRef.props.height === innerListRef.current.scrollHeight) {
      onScrollBottomBorder();
    }
  }, [isReverse, onLoadRequest, onScroll]);
  var handleLoadRequest = (0, _react.useCallback)(function (startIndex, stopIndex) {
    if (!isReverse) {
      onLoadRequest(startIndex, stopIndex);
    }
  }, [onLoadRequest, isReverse]);
  var getItemSize = (0, _react.useCallback)(function (index) {
    return itemSizes[index] || DEFAULT_ITEM_SIZE;
  }, [itemSizes, itemSizes.length]);
  var checkScrollIsHidden = (0, _react.useCallback)(function () {
    if (listRef.current && listRef.current.props) {
      var listRefProps = listRef.current.props;
      var sizes = itemSizes.reduce(function (acc, item) {
        return acc + item;
      }, 0);
      return listRefProps.height >= sizes;
    }
    return false;
  }, [itemSizes, itemSizes.length]);
  var handlePolygonsRendered = (0, _react.useCallback)(function () {
    calculateItemSizes();
    if (isStartReverseScrollToBottom) {
      var lastMessageIndex = itemData.length - 1;
      listRef.current.scrollToItem(lastMessageIndex);
      setIsStartReverseScrollToBottom(false);
    }
  }, [itemData, isStartReverseScrollToBottom]);
  var handleDidUpdateItems = (0, _react.useCallback)(function () {
    if (isReversePaginationStart) {
      scrollToLastItemReverse();
    }
    onDidUpdateItems();
  }, [onDidUpdateItems, itemSizes, isReversePaginationStart]);
  (0, _react.useEffect)(function () {
    if (isReverse && !isNextPageLoading) {
      setIsReversePaginationStart(true);
    }
  }, [isNextPageLoading]);
  (0, _react.useEffect)(function () {
    setIsPolygonCalculation(true);
  }, [itemData, itemData.length]);
  (0, _hooks.useDidUpdate)(function () {
    if (listRef.current) {
      handleDidUpdateItems();
      Object.values(itemSizes).forEach(function (value, index) {
        var prevValue = prevItemSizes[index];
        if ((!prevValue || prevValue !== value) && (0, _has2["default"])(listRef, 'current.resetAfterIndex')) {
          listRef.current.resetAfterIndex(index);
        }
      });
    }
  }, [prevItemSizes, itemSizes, itemSizes.length]);
  var listComponent = flexible ? /*#__PURE__*/_react["default"].createElement(_reactWindow.VariableSizeList, {
    ref: outerRef
  }) : /*#__PURE__*/_react["default"].createElement(_reactWindow.FixedSizeList, {
    ref: outerRef
  });
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, (!flexible || flexible && itemSizes.length > 0) && /*#__PURE__*/_react["default"].createElement(_reactVirtualizedAutoSizer["default"], null, function (_ref7) {
    var height = _ref7.height,
      width = _ref7.width;
    return /*#__PURE__*/_react["default"].createElement(_reactWindowInfiniteLoader["default"], {
      isItemLoaded: isItemLoaded,
      itemCount: itemCount,
      loadMoreItems: handleLoadRequest,
      minimumBatchSize: minimumBatchSize,
      threshold: threshold
    }, function (_ref8) {
      var onItemsRenderedInner = _ref8.onItemsRendered,
        ref = _ref8.ref;
      return /*#__PURE__*/_react["default"].createElement(StyledVirtualizedList, (0, _extends2["default"])({
        height: height,
        width: width,
        itemCount: itemCount,
        itemSize: getItemSize,
        component: listComponent,
        onItemsRendered: function onItemsRendered(innerProps) {
          var renderProps = _objectSpread({}, innerProps);
          if (flexible) {
            renderProps.height = itemSizes.reduce(function (acc, item) {
              return acc + item;
            }, 0);
          }
          onItemsRenderedInner(renderProps);
          _onItemsRendered(renderProps);
        },
        threshold: threshold,
        forwardRef: function forwardRef(component) {
          if ((0, _isFunction2["default"])(outerRef)) {
            outerRef(component);
          } else if (outerRef) {
            outerRef.current = component;
          }
          ref(component);
          listRef.current = component;
        },
        innerRef: innerListRef,
        onScroll: handleScroll,
        itemData: itemData,
        isColumnReverse: isReverse && checkScrollIsHidden()
      }, restProps), children);
    });
  }), isPolygonCalculation && flexible && children && /*#__PURE__*/_react["default"].createElement(PolygonList, {
    itemData: itemData,
    polygons: children,
    ref: polygonRef,
    onPolygonsRendered: handlePolygonsRendered
  }));
});
InfiniteList.displayName = 'InfiniteList';
InfiniteList.propTypes = {
  isItemLoaded: _propTypes["default"].func,
  itemCount: _propTypes["default"].number.isRequired,
  polygons: _propTypes["default"].arrayOf(_propTypes["default"].node),
  minimumBatchSize: _propTypes["default"].number,
  onLoadRequest: _propTypes["default"].func,
  threshold: _propTypes["default"].number,
  flexible: _propTypes["default"].bool,
  onScrollTopBorder: _propTypes["default"].func,
  onScrollBottomBorder: _propTypes["default"].func,
  onScroll: _propTypes["default"].func,
  isReverse: _propTypes["default"].bool,
  onDidUpdateItems: _propTypes["default"].func,
  onItemsRendered: _propTypes["default"].func,
  children: _propTypes["default"].func.isRequired,
  itemData: _propTypes["default"].arrayOf(_propTypes["default"].shape({})).isRequired
};
InfiniteList.defaultProps = {
  isItemLoaded: Function.prototype,
  minimumBatchSize: MINIMUM_BATCH_SIZE,
  onLoadRequest: Function.prototype,
  threshold: THRESHOLD_DEFAULT,
  flexible: false,
  polygons: null,
  onScrollTopBorder: Function.prototype,
  onScrollBottomBorder: Function.prototype,
  onScroll: Function.prototype,
  isReverse: false,
  onDidUpdateItems: Function.prototype,
  onItemsRendered: Function.prototype
};
PolygonList.propTypes = {
  polygons: _propTypes["default"].arrayOf(_propTypes["default"].node).isRequired,
  onPolygonsRendered: _propTypes["default"].func.isRequired
};
var _default = exports["default"] = InfiniteList;